export const MARGIN = {
  top: 20,
  right: 50,
  bottom: 36,
  left: 50,
};

export const Y_LABEL_X_OFFSET = 12;
export const Y_LABEL_Y_OFFSET = 4;

export const TICK_WIDTH = 12;
export const LABEL_Y_OFFSET = 20;

export const LEGEND_ITEMS = [
  { text: '샛별배송', color: '#BD76FF' },
  { text: '하루배송(택배)', color: '#5094DC' },
  { text: '지연배송', color: '#F1C236' },
  { text: '배송실패', color: '#E22D2E' },
];
